// tslint:disable: quotemark
export enum TypeOfEmployeeEnum {
	Employee = 0,
	TenNinetyNine = 1,
	SubContracted = 2
}

export namespace TypeOfEmployeeEnum {
	export function toDescription(val: TypeOfEmployeeEnum) {
		switch (val) {
			case 0:
				return "Employee";
			case 1:
				return "1099";
			case 2:
				return "Sub-Contracted";
		}
		return null;
	}
}
